import { AxiosWebApiClient } from '@/core/webapi/WebApiClient';
import { CurrencyCode } from '@/models/core/currency';

export class Balances implements Record<string, any> {
    data: Record<string, any> | null = null;

    webapiClient = new AxiosWebApiClient(`${process.env.VUE_APP_API_HOST}`);

    autoUpdate = true;

    updateTimer: any = null;

    get hasData(): boolean {
      return !!this.data;
    }

    hasBalanceForCurrency(currency): boolean {
      return this.hasData && (currency in this.data);
    }

    getBalance(currency) {
      let result = this.data ? +this.data[currency] : 0;
      if (currency === CurrencyCode.USDT) result += +this.data[CurrencyCode.USDTt];
      return result;
    }

    resetAutoUpdateTimer() {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
        this.updateTimer = null;
      }
    }

    delayedUpdateBalances() {
      this.updateTimer = setTimeout(() => {
        if (this.autoUpdate) this.updateBalances();
      }, 900000);
    }

    updateBalances() {
      this.webapiClient.call('/webapi/webapi/layout').then((result: any) => {
        this.data = result.data.balance;
        this.delayedUpdateBalances();
      });
    }
}
